export default "__VITE_ASSET__Dh5i3ybj__"